import { ApiBase } from './ApiBase';
export class EntitlementApiImpl extends ApiBase {
    getEntitlementService() {
        return this.getAdaptableApi().internalApi.getEntitlementService();
    }
    getEntitlementAccessLevelForModule(adaptableModule) {
        return this.getEntitlementService().getEntitlementAccessLevelForModule(adaptableModule);
    }
    isObjectReadonly(object) {
        return object.IsReadOnly;
    }
    isModuleHiddenEntitlement(adaptableModule) {
        return this.getEntitlementService().isModuleHiddenEntitlement(adaptableModule);
    }
    isModuleFullEntitlement(adaptableModule) {
        return this.getEntitlementService().isModuleFullEntitlement(adaptableModule);
    }
    isModuleReadOnlyEntitlement(adaptableModule) {
        return this.getEntitlementService().isModuleReadOnlyEntitlement(adaptableModule);
    }
}
